<div class="coming-soon-modal">
    <div class="text-center">
        <img class="img" src="assets/img/coming-soon-icon.svg" alt="">
        <h3>{{data.message1?data.message1:'Coming soon!'}}!</h3>
        <p>{{data.message2?data.message2: "This button will be enabled 10 minutes before the scheduled test time." +  (data?.scheduledTime ? "Scheduled test time is: " + data?.scheduledTime + ".": "")}}</p>
        <button class="btn-link" type="button" (click)="onClose()">CLOSE</button>
    </div>
</div>